import { inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { DashboardClient } from '../../../../core/openapi/bff-admin-api';
import { catchError, defer, finalize, Observable, of } from 'rxjs';
import { LoadingState } from '../../../../shared/types/loading.type';
import { ToastService } from '@ui-lib/components';
import { TranslateService } from '@ngx-translate/core';
import { outputError } from '../../../../shared/utils/output-error.function';
import { IFacilityDashboardInfo } from './facilities-overview.model';

@Injectable()
export class FacilitiesOverviewService {
  private readonly dashboardClient = inject(DashboardClient);
  private readonly toastService = inject(ToastService);
  private readonly translateService = inject(TranslateService);

  private readonly _loadingStatus: WritableSignal<LoadingState> = signal<LoadingState>(
    LoadingState.IDLE,
  );
  public readonly loadingStatus: Signal<LoadingState> = this._loadingStatus.asReadonly();

  public readonly facilities$: Observable<IFacilityDashboardInfo[]> = defer(() => {
    this._loadingStatus.set(LoadingState.LOADING);
    return this.dashboardClient.v1DashboardFacilityInfoGet();
  }).pipe(
    catchError((error) => {
      this.toastService.error({
        message: this.translateService.instant(
          'monitoring.dashboard.facilities-overview.toast.fetching-failed',
          { error: outputError(error, this.translateService.instant('errors.unknown')) },
        ),
      });
      return of([]);
    }),
    finalize(() => this._loadingStatus.set(LoadingState.READY)),
  );
}
